// https://stash.aexp.com/stash/projects/ONE/repos/amex-iguazu-resources/browse/src/memberProducts.js
const memberProducts = {
  fetch: (id, action, state) => ({
    url: `${state.getIn(['config', 'mycaAPIUrl'])}/servicing/v1/member`,
    opts: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  }),
};

export default memberProducts;
